import React from 'react';
import { Helmet } from 'react-helmet';

export default function HtmlToMarkdownGuide() {
  return (
    <main className="container mx-auto px-4 py-12">
      <Helmet>
        <title>How to Convert HTML to Markdown (Simple Guide) | WebUtility</title>
        <meta name="description" content="Learn when and why you should convert HTML to Markdown for cleaner, easier-to-read content, and how to do it instantly." />
      </Helmet>

      <h1 className="text-3xl font-bold mb-4">How to Convert HTML to Markdown (Simple Guide)</h1>
      <p className="mb-4 text-gray-600">
        Markdown is a lightweight way to format text, easier to read and edit compared to HTML. Learn when to convert HTML to Markdown and how to do it instantly.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Why Convert to Markdown?</h2>
      <ul className="list-disc ml-6">
        <li>Faster editing.</li>
        <li>Simpler syntax.</li>
        <li>Better readability in plain text editors.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Steps to Convert:</h2>
      <ol className="list-decimal ml-6">
        <li>Open <a href="/texttools" className="text-blue-600 underline">Markdown Converter</a>.</li>
        <li>Paste HTML code.</li>
        <li>Click <strong>"Convert to Markdown"</strong>.</li>
      </ol>
    </main>
  );
}
